'use strict'

class RoleFormCtrl {

    constructor ($state, $stateParams, Role, $mdToast, $templateCache, $http) {

        this.$templateCache = $templateCache
        this.$state = $state
        this._Role = Role
        this.buttonDisabled = false
        this.$mdToast = $mdToast
        this.$http = $http
        this.$stateParams = $stateParams
        // this.pluralize = pluralize;

        this.permissions = {}
        this.allPermissions = {}
        this.groupedPermissions = []
        this.restPermissions = []
        this.labels = {}

        this.connectedUsers = []

        this.getPermissions()

        this.formdata = {
            active: true
        }

        /// PAGINATOR ///
        this.pagination = {
            current: 1
        }

        if ($stateParams.id) {
            this.getUsers()

            Role.get({ id: $stateParams.id }, (data) => {
                this.buttonDisabled = parseInt(data.id) === 1
                angular.extend(this.formdata, data)
                delete this.formdata.permissions
                data.permissions.forEach((permission) => {
                    this.permissions[permission.id] = true
                })
            })
        }
    }

    getPermissions () {

        return this.$http.get('/permissions').then((response) => {
            var allPerms = response.data
            var groupedBy = {
                items: {},
                templates: {},
                contacts: {},
                campaigns: {},
                broadcasts_planned: {},
                broadcasts_unplanned: {},
                programs: {},
                presenters: {},
            }
            allPerms.forEach((permission) => {
                let parts = permission.name.split('.')
                let key = parts[0], action = parts[1]
                if (action === 'view' || action === 'management') {
                    if (!groupedBy[key]) groupedBy[key] = {}
                    groupedBy[key][action] = permission
                } else if (action === 'view_planned' || action === 'management_planned') {
                    key = key + "_planned"
                    action = action.slice(0, -8)
                    if (!groupedBy[key]) groupedBy[key] = {}
                    groupedBy[key][action] = permission
                } else if (action === 'view_unplanned' || action === 'management_unplanned') {
                    key = key + "_unplanned"
                    action = action.slice(0, -10)
                    if (!groupedBy[key]) groupedBy[key] = {}
                    groupedBy[key][action] = permission
                } else {
                    this.restPermissions.push(permission)
                }
            })

            this.groupedPermissions = groupedBy

            for (let key in allPerms) {
                if (allPerms.hasOwnProperty(key)) {
                    allPerms[key].formKey = key
                    this.allPermissions[allPerms[key].id] = allPerms[key]
                }
            }

            let keys = Object.keys(this.groupedPermissions).map((key) => {
                let _key = key

                let exceptions = [
                    'stories'
                ]

                if (exceptions.indexOf(key) < 0) {
                    key = 'labels.' + key.charAt(0).toUpperCase() + key.slice(1)

                    if (key.slice(-1) === 's') {
                        key = key.slice(0, -1)
                        this.groupedPermissions[_key].label = key
                        return [key, 2]
                    } else {
                        this.groupedPermissions[_key].label = key
                        return key
                    }
                } else {
                    key = 'labels.' + key.charAt(0).toUpperCase() + key.slice(1)
                    if (key.slice(-3) === 'ies') {
                        key = key.slice(0, -3) + 'y'
                        this.groupedPermissions[_key].label = key
                        return [key, 2]
                    }
                }
            })

            this.$http.post('/translate', keys, { cache: true }).then((res) => {
                this.labels = res.data
            })

        })
    }

    //this date transform the custom date to 'new Date' so it can be re-used
    makeDate (date) {
        return new Date(date)
    }

    cancel () {
        this.$state.go('role')
    }

    getUsers (pageNumber) {
        this.$http.get('/users/byrole/' + this.$stateParams.id + '?page=' + pageNumber).then((response) => {
            this.connectedUsers = response.data.data.data
            this.totalResults = response.data.data.total
            this.resultPerPage = response.data.data.per_page
        })
        this.pageChanged = function (newPage) {
            getResultsPage(newPage)
        }

    }

    save ($valid) {

        if (!$valid) {
            return
        }

        this.buttonDisabled = true

        let modelData = angular.copy(this.formdata)
        modelData['permissions'] = this.permissions

        this._Role.save(modelData, (data) => {

            //Clear cached Template
            this.$templateCache.remove('/partial/app.partials.role.detail')
            this.$templateCache.remove('/partial/app.partials.user.detail')

            if (this.formdata.id) {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.saved?object=role&title=' + this.formdata.name,
                    hideDelay: 3000,
                    position: ('top right')
                })

                this.$state.go('role.update', { id: data.id }, { 'reload': true })

            } else {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.create?object=role&title=' + this.formdata.name, //@trans('labels.role')
                    hideDelay: 3000,
                    position: ('top right')
                })

                this.$state.go('role.update', { id: data.id }, { 'reload': true })
            }
        })
    }

    permissionChange (permId) {

        let bool = this.permissions[permId]

        let recursiveOff = []

        if (bool) {
            let depends = this.allPermissions[permId].dependencies
            if (depends) {
                depends.forEach((id) => {
                    var toggle = !this.permissions[id]
                    this.permissions[id] = true
                    if (toggle) {
                        this.permissionChange(id)
                    }
                })
            }
        } else {
            for (var id in this.allPermissions) {
                if (this.allPermissions[id].dependencies && this.allPermissions[id].dependencies.indexOf(permId) > -1) {
                    recursiveOff.push(this.allPermissions[id].id)
                }
            }
        }

        recursiveOff.forEach((id) => {
            var toggle = this.permissions[id]
            this.permissions[id] = false
            if (toggle) {
                this.permissionChange(id)
            }
        })

    }

}

RoleFormCtrl.$inject = ['$state', '$stateParams', 'Role', '$mdToast', '$templateCache', '$http']

module.exports = RoleFormCtrl
